import { render, staticRenderFns } from "./completed-payment.vue?vue&type=template&id=71b9c088"
import script from "./completed-payment.vue?vue&type=script&lang=js"
export * from "./completed-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports